import { render, staticRenderFns } from "./InfoPanelCardWrapper.vue?vue&type=template&id=92cc06c8"
import script from "./InfoPanelCardWrapper.vue?vue&type=script&lang=ts"
export * from "./InfoPanelCardWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports